module.exports = __webpack_public_path__ + "img/route.3b1477e7.svg";